import React from "react";
import { useNavigate } from "react-router-dom";
import roomHero from "../assets/h1.jpg";
import taxiService from "../assets/yb (50).jpg";

// eslint-disable-next-line no-unused-vars -- used in commented section, re-enable when uncommenting rooms UI
const rooms = [
  {
    name: "Triple",
    roomType: "triple",
    price: "$40",
    description: "Night",
    highlight: "Perfect for families and small groups",
    image:
      "https://media.istockphoto.com/id/157672262/photo/large-bedroom-in-a-safari-tent.jpg?s=612x612&w=0&k=20&c=d9FgtQ0MQXD3G-yVXbEg3ATnXnMm5Mw2Ru8e8NR6TLY=",
  },
  {
    name: "Double",
    roomType: "double",
    price: "$32",
    description: "Night",
    highlight: "Ideal for couples seeking comfort",
    image:
      "https://www.virginlimitededition.com/media/m0uj0rk3/ulusaba-safari-lodge-river-room-2-2.jpg?width=600&height=480&quality=70&v=1dc4a5ecb6a6100",
  },
  {
    name: "Hostel",
    roomType: "hostel",
    price: "$10",
    description: "Night",
    highlight: "Budget-friendly stays for solo explorers",
    image:
      "https://images.unsplash.com/photo-1664227430717-9a62112984cf?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fHRyYXZlbCUyMGhvdGVsfGVufDB8fDB8fHww",
  },
];

const Rooms = () => {
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars -- used in commented section, re-enable when uncommenting rooms UI
  const handleRoomClick = (roomType) => {
    // navigate(`/room/${roomType.toLowerCase()}`);
    alert("This room is not available yet");
    console.log(roomType);
    

  };

  const handleTaxiServiceClick = () => {
    navigate("/taxi-service");
  };

  return (
    <main className="ui-mdc-rooms-page bg-gradient-to-b from-[#1a1f28] via-[#202834] to-[#0a0d12] text-white min-h-screen">
      {/* Hero Section */}
      <section className="ui-mdc-rooms-hero relative flex min-h-[70vh] items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={roomHero}
            alt="Luxury safari lodge"
            className="h-full w-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black/80" />
        </div>
        <div className="ui-mdc-rooms-hero-overlay absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(196,145,95,0.2),_transparent_55%)]" aria-hidden="true" />

        <div className="ui-mdc-rooms-hero-content relative z-10 mx-auto max-w-4xl px-6 text-center">
          <span className="ui-mdc-rooms-kicker inline-flex items-center rounded-full bg-white/10 px-4 py-2 text-sm font-medium uppercase tracking-widest text-amber-200/90">
            Book a ride with Yala Vibe
          </span>
          <h1 className="ui-mdc-rooms-title mt-6 text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
          Comfortable rides crafted for every traveller
          </h1>
          <p className="ui-mdc-rooms-subtitle mt-6 text-lg text-gray-300 sm:text-xl">
            From family vans to budget-friendly tuk-tuks, our handpicked fleet keeps you moving safely and comfortably to your destination.
          </p>
        </div>
      </section>

      {/* Rooms Section */}
      {/* <section className="ui-mdc-rooms-section relative py-20">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(25,46,59,0.3),_transparent_65%)]" />
        <div className="relative mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
          <div className="ui-mdc-rooms-header mx-auto max-w-3xl text-center">
            <span className="ui-mdc-rooms-chip inline-flex items-center rounded-full bg-[#c4915f]/10 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-amber-200/90">
              <span className="ui-mdc-rooms-chip-icon mr-2 h-2 w-2 rounded-full bg-[#c4915f]" aria-hidden="true"></span>
              Choose your stay
            </span>
            <h2 className="ui-mdc-rooms-heading mt-4 text-3xl font-semibold tracking-tight text-white sm:text-4xl">
              Rooms designed around your plan
            </h2>
            <p className="ui-mdc-rooms-description mt-4 text-base text-gray-300">
              Pick a room category to match your safari itinerary. Each option
              includes early breakfast, curated wildlife briefings, and flexible
              transfer add-ons.
            </p>
          </div>

          <div className="ui-mdc-rooms-grid mt-16">
            {rooms.map((room) => (
              <article
                key={room.roomType}
                className="ui-mdc-room-card group cursor-pointer"
                onClick={() => handleRoomClick(room.roomType)}
              >
                <div className="ui-mdc-room-media relative overflow-hidden rounded-t-2xl">
                  <img src={room.image} alt={room.name} className="ui-mdc-room-img h-64 w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="ui-mdc-room-overlay absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                  <span className="ui-mdc-room-tag absolute left-6 top-6 inline-flex items-center rounded-full bg-white/90 px-4 py-2 text-sm font-semibold uppercase tracking-wide text-gray-900 shadow-lg">
                    {room.name}
                  </span>
                  <div className="ui-mdc-room-overlay-content absolute bottom-0 left-0 right-0 p-6 text-white opacity-0 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0" style={{ transform: 'translateY(100%)' }}>
                    <p className="ui-mdc-room-primary text-lg font-semibold">{room.highlight}</p>
                    <p className="ui-mdc-room-price mt-2 text-2xl font-bold">
                      {room.price}
                      <span className="ui-mdc-room-price-sub ml-2 text-base font-normal text-white/70">{room.description}</span>
                    </p>
                  </div>
                </div>

                <div className="ui-mdc-room-body rounded-b-2xl border-x border-b border-white/10 bg-white/5 p-6 backdrop-blur-sm transition-all duration-300 group-hover:border-white/20 group-hover:bg-white/10">
                  <h3 className="ui-mdc-room-title text-xl font-semibold text-white">{room.name}</h3>
                  <p className="ui-mdc-room-text mt-3 text-sm leading-relaxed text-gray-300">
                    {room.highlight}. Early check-ins available on request, plus
                    complimentary welcome refreshments.
                  </p>
                  <button className="ui-mdc-room-button mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#c4915f] transition-colors duration-200 hover:text-amber-300" type="button">
                    Explore room details
                    <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section> */}

      {/* Taxi Service Section */}
      <section className="ui-mdc-taxi-section relative border-t border-white/10 bg-gradient-to-br from-black/40 via-[#1a1f28] to-black/40 py-20">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom,_rgba(196,145,95,0.15),_transparent_55%)]" />
        <div className="relative mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
          <div className="ui-mdc-taxi-header mx-auto max-w-3xl text-center">
            <span className="ui-mdc-taxi-chip inline-flex items-center rounded-full bg-[#c4915f]/10 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-amber-200/90">
              <span className="ui-mdc-taxi-chip-icon mr-2 h-2 w-2 rounded-full bg-[#c4915f]" aria-hidden="true"></span>
              Seamless journeys
            </span>
            <h2 className="ui-mdc-taxi-heading mt-4 text-3xl font-semibold tracking-tight text-white sm:text-4xl">
              Dedicated safari taxi service
            </h2>
            <p className="ui-mdc-taxi-description mt-4 text-base text-gray-300">
              Reliable jeeps and air-conditioned transfers to keep your group safe
              and on schedule from airport to park gate.
            </p>
          </div>

          <div className="ui-mdc-taxi-grid mt-16">
            <div className="ui-mdc-taxi-media relative overflow-hidden rounded-3xl border border-white/10 shadow-2xl">
              <img
                src={taxiService}
                alt="Taxi service for safari guests"
                className="ui-mdc-taxi-image h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-black/50 via-transparent to-black/20" />
            </div>

            <div className="ui-mdc-taxi-content">
              <h3 className="ui-mdc-taxi-title text-2xl font-semibold text-white">Taxi service highlights</h3>
              <p className="ui-mdc-taxi-text mt-4 text-base leading-relaxed text-gray-300">
                Licensed drivers, route planning by our operations team, and round-the-clock
                availability for airport runs or bespoke excursions.
              </p>
              <ul className="ui-mdc-taxi-list mt-6 space-y-3">
                <li className="ui-mdc-taxi-list-item flex items-start gap-3 text-gray-200">
                  <svg className="mt-1 h-5 w-5 flex-shrink-0 text-[#c4915f]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span>Chauffeurs trained in park etiquette</span>
                </li>
                <li className="ui-mdc-taxi-list-item flex items-start gap-3 text-gray-200">
                  <svg className="mt-1 h-5 w-5 flex-shrink-0 text-[#c4915f]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span>Jeep upgrades with open roofs available</span>
                </li>
                <li className="ui-mdc-taxi-list-item flex items-start gap-3 text-gray-200">
                  <svg className="mt-1 h-5 w-5 flex-shrink-0 text-[#c4915f]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span>Multi-day itineraries & city tours</span>
                </li>
                <li className="ui-mdc-taxi-list-item flex items-start gap-3 text-gray-200">
                  <svg className="mt-1 h-5 w-5 flex-shrink-0 text-[#c4915f]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span>24/7 concierge support</span>
                </li>
              </ul>
              <button
                className="ui-mdc-taxi-button mt-8 inline-flex items-center justify-center rounded-md bg-[#c4915f] px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-[#c4915f]/30 transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#b37f4a] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#c4915f]"
                type="button"
                onClick={handleTaxiServiceClick}
              >
                Book a taxi
              </button>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Rooms;
 